import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

// Custom SVG icons with modern filled style
const Icons = {
  Obra: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg>,
  Mail: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>,
  Dashboard: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>,
  Clients: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>,
  Projects: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20 6h-2.18c.07-.44.18-.88.18-1.34C18 2.54 15.96.5 13.5.5c-1.32 0-2.5.56-3.36 1.44L9 3.06 7.86 1.94C7 1.06 5.82.5 4.5.5 2.04.5 0 2.54 0 4.66 0 5.12.11 5.56.18 6H-2C-2 6 2 6 2 6H1c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM13.5 2.5c1 0 1.5.75 1.5 2.16 0 .46-.11.9-.18 1.34H9.18C9.11 5.56 9 5.12 9 4.66c0-1.41.5-2.16 1.5-2.16zm-9 0C5.5 2.5 6 3.25 6 4.66c0 .46-.11.9-.18 1.34H3.18C3.11 5.56 3 5.12 3 4.66 3 3.25 3.5 2.5 4.5 2.5zM20 19H2V8h18v11z"/></svg>,
  Quotes: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>,
  Calendar: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/></svg>,
  Agenda: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/></svg>,
  Calculator: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2v-4H8v-2h4V7h2v4h4v2h-4v4z"/></svg>,
  TechSheets: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z"/></svg>,
  Admin: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>,
  Precios: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>,
  Menu: () => <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>,
  Close: () => <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>,
  Logout: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>,
  Profile: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>,
};

const ALL_NAV = [
  { to: '/dashboard',    Icon: Icons.Dashboard,   label: 'Dashboard',         roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/clientes',     Icon: Icons.Clients,     label: 'Clientes',          roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/citas',        Icon: Icons.Calendar,    label: 'Citas',             roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/agenda',       Icon: Icons.Agenda,      label: 'Agenda compartida', roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario','tecnico'] },
  { to: '/proyectos',    Icon: Icons.Projects,    label: 'Proyectos',         roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/calculadora',  Icon: Icons.Calculator,  label: 'Calculadora',       roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario','tecnico'] },
  { to: '/obra',         Icon: Icons.Obra,        label: 'Obra',              roles: ['master','admin','gerente_financiera','gerente_proyectos','tecnico','usuario'] },
  { to: '/cotizaciones', Icon: Icons.Quotes,      label: 'Cotizaciones',      roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/hojas-tecnicas', Icon: Icons.TechSheets, label: 'Hojas tecnicas',  roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
  { to: '/correo-masivo',  Icon: Icons.Mail,       label: 'Correo masivo',    roles: ['master','admin','gerente_financiera','gerente_proyectos','usuario'] },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navItems = ALL_NAV.filter(item => !item.roles || item.roles.includes(user?.rol));

  const handleLogout = () => { logout(); navigate('/login'); };
  const initials = user ? `${user.nombre[0]}${user.apellido[0]}`.toUpperCase() : 'U';
  const rolLabel = {
    master: 'Master', admin: 'Admin',
    gerente_financiera: 'Ger. Financiera', gerente_proyectos: 'Ger. Proyectos', usuario: 'Usuario', tecnico: 'Técnico'
  }[user?.rol] || 'Usuario';

  const linkStyle = (isActive) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 12px', borderRadius: 8, marginBottom: 2,
    textDecoration: 'none', fontSize: 13, fontWeight: 500,
    color: isActive ? 'white' : '#888',
    background: isActive ? '#7B0D0D' : 'transparent',
    transition: 'all 0.15s',
  });

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 40 }} />
      )}

      <aside style={{
        width: 240, background: '#0d0d0d', display: 'flex', flexDirection: 'column',
        flexShrink: 0, zIndex: 50, position: 'fixed', top: 0, bottom: 0, left: 0,
        transform: sidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.25s ease'
      }} className="sidebar-desktop">

        {/* Logo */}
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #2d2d2d' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, background: '#7B0D0D', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="22" height="22" viewBox="0 0 180 120" xmlns="http://www.w3.org/2000/svg">
                <g stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="8" y1="55" x2="33" y2="55"/><line x1="8" y1="65" x2="30" y2="65"/>
                  <line x1="147" y1="55" x2="172" y2="55"/><line x1="150" y1="65" x2="172" y2="65"/>
                  <line x1="33" y1="13" x2="52" y2="34"/><line x1="41" y1="9" x2="59.5" y2="30"/>
                  <line x1="147" y1="13" x2="128" y2="34"/><line x1="139" y1="9" x2="120.5" y2="30"/>
                  <line x1="33" y1="107" x2="52" y2="86"/><line x1="41" y1="111" x2="59.5" y2="90"/>
                  <line x1="147" y1="107" x2="128" y2="86"/><line x1="139" y1="111" x2="120.5" y2="90"/>
                  <polygon points="58,26 122,26 150,60 122,94 58,94 30,60" fill="none" strokeWidth="3.5"/>
                  <polygon points="63,34 117,34 137,60 117,86 63,86 43,60" fill="rgba(255,255,255,0.3)" strokeWidth="2"/>
                </g>
              </svg>
            </div>
            <div>
              <div style={{ color: 'white', fontWeight: 700, fontSize: 14, letterSpacing: 1 }}>ODIN SYSTEM</div>
              <div style={{ color: '#555', fontSize: 10 }}>CRM v2.0</div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '10px 10px', overflowY: 'auto' }}>
          {navItems.map(({ to, Icon, label }) => (
            <NavLink key={to} to={to} onClick={() => setSidebarOpen(false)}
              style={({ isActive }) => linkStyle(isActive)}>
              <Icon />{label}
            </NavLink>
          ))}
          {isAdmin && (
            <>
              <div style={{ margin: '10px 0 6px', padding: '0 12px', fontSize: 10, color: '#444', textTransform: 'uppercase', letterSpacing: 1 }}>
                Administracion
              </div>
              <NavLink to="/admin" onClick={() => setSidebarOpen(false)}
                style={({ isActive }) => linkStyle(isActive)}>
                <Icons.Admin />Panel Admin
              </NavLink>
              <NavLink to="/precios" onClick={() => setSidebarOpen(false)}
                style={({ isActive }) => linkStyle(isActive)}>
                <Icons.Precios />Precios
              </NavLink>
            </>
          )}
        </nav>

        {/* User */}
        <div style={{ padding: '12px 14px', borderTop: '1px solid #2d2d2d' }}>
          <NavLink to="/perfil" onClick={() => setSidebarOpen(false)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, textDecoration: 'none' }}>
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#7B0D0D', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12, flexShrink: 0 }}>
              {initials}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ color: 'white', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user?.nombre} {user?.apellido}
              </div>
              <div style={{ color: '#555', fontSize: 10 }}>{rolLabel}</div>
            </div>
          </NavLink>
          <button onClick={handleLogout}
            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '8px', background: '#1a1a1a', color: '#666', border: '1px solid #333', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
            <Icons.Logout /> Cerrar sesion
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }} className="main-content">
        <header style={{ background: 'white', borderBottom: '1px solid #e5e5e5', padding: '0 20px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, zIndex: 30 }}>
          <button onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{ padding: 8, background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#333' }}>
            {sidebarOpen ? <Icons.Close /> : <Icons.Menu />}
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 13, color: '#666' }}>Hola, <strong>{user?.nombre}</strong></span>
            <NavLink to="/perfil" style={{ textDecoration: 'none' }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#7B0D0D', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 11 }}>
                {initials}
              </div>
            </NavLink>
          </div>
        </header>
        <main style={{ flex: 1, overflowY: 'auto', padding: '20px 16px' }}>
          <Outlet />
        </main>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .sidebar-desktop { transform: translateX(0) !important; position: relative !important; }
          .main-content { margin-left: 0 !important; }
        }
        nav a:hover { background: #1a1a1a !important; color: #ccc !important; }
      `}</style>
    </div>
  );
}
